import { Injectable } from '@angular/core';
import { FeatureFlag } from '@core/const';
import { FeatureFlagActions, FeatureFlagSelectors, StateWithCore } from '@core/data-access';
import { Store, select } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  constructor(private store: Store<StateWithCore>) {}

  init(): void {
    this.store.dispatch(new FeatureFlagActions.FeatureFlagsLoad());
  }

  isEnabled(code: string): Observable<boolean> {
    return this.store.pipe(
      select(FeatureFlagSelectors.getFeatureFlagsState),
      filter((state) => Boolean(state.success || state.error)),
      map((state: StateUtils.LoaderState<FeatureFlag[]>) => {
        if (!Array.isArray(state.value)) {
          console.warn('При получении флага <%s> произошла ошибка, используется значение по умолчанию', code);

          return false;
        }

        const flag = state.value.find((f) => f.code === code);

        if (!flag) {
          console.warn('Попытка получить не существующий флаг <%s>', code);

          return false;
        }

        return flag.enabled;
      }),
    );
  }
}
